/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_DisabledInputs */



/**
* | output |
* | --- |
* | "Disabled" |
*
* @param {Team_Manager_DisabledInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_disabled = /** @type {((inputs?: Team_Manager_DisabledInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_DisabledInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Désactivé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Deaktiviert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Disabili")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Неполноценный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desactivado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已禁用")
	if (locale === "ja") return /** @type {LocalizedString} */ ("無効")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अक्षम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desabilitado")
	return /** @type {LocalizedString} */ ("Disabled")
});